import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["inert"]
const _hoisted_2 = { class: "sc__field" }
const _hoisted_3 = { class: "sc__opt" }
const _hoisted_4 = { class: "sc__opt" }
const _hoisted_5 = { class: "sc__opt" }
const _hoisted_6 = { class: "sc__opt" }
const _hoisted_7 = { class: "sc__field" }
const _hoisted_8 = { class: "sc__opt" }
const _hoisted_9 = { class: "sc__opt" }
const _hoisted_10 = { class: "sc__opt" }
const _hoisted_11 = { class: "sc__opt" }
const _hoisted_12 = { class: "sc__field" }
const _hoisted_13 = { class: "sc__field" }
const _hoisted_14 = { class: "sc__field" }
const _hoisted_15 = { class: "sc__field" }
const _hoisted_16 = { class: "sc__field" }
const _hoisted_17 = { class: "sc__field" }
const _hoisted_18 = { class: "sc__field" }
const _hoisted_19 = { class: "sc__field" }
const _hoisted_20 = { class: "sc__field" }
const _hoisted_21 = { class: "sc__field" }
const _hoisted_22 = {
  key: 1,
  class: "sc-annex2-read"
}

import ScMark from '@/components/contract/ScMark.vue'
import ScEditText from '@/components/contract/ScEditText.vue'
import ScEditDate from '@/components/contract/ScEditDate.vue'
import type { ServiceContractForm } from '@/composables/useServiceContractForm'

/* form은 부모가 내려준 반응형 계약서 모델 — 작성 화면·문서 화면이 함께 쓴다 */

export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceContractAnnex2Doc',
  props: {
    form: {},
    locked: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

/* 요금을 고르면 그 서비스는 「선택」이 된다 */
function pickWageFee(v: 'flat' | 'headcount' | 'custom') {
  props.form.wageSelect = 'selected'
  props.form.wageFee = v
}
function pickAcctFee(v: 'flat' | 'volume' | 'custom') {
  props.form.acctSelect = 'selected'
  props.form.acctFee = v
}
function toggleWageNone() {
  props.form.wageSelect = props.form.wageSelect === 'unselected' ? 'selected' : 'unselected'
}
function toggleAcctNone() {
  props.form.acctSelect = props.form.acctSelect === 'unselected' ? 'selected' : 'unselected'
}

return (_ctx: any,_cache: any) => {
  return (__props.form.annex2Mode !== 'text')
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({ 'sc-annex2-locked': __props.locked }),
        inert: __props.locked ? '' : undefined
      }, [
        _cache[81] || (_cache[81] = _createElementVNode("h3", null, "1. 선택한 서비스의 이용요금 (미선택 서비스는 “해당 없음” 표시)", -1)),
        _createElementVNode("p", _hoisted_2, [
          _cache[48] || (_cache[48] = _createTextVNode(" 임금관리: ", -1)),
          _createElementVNode("span", _hoisted_3, [
            _createVNode(ScMark, {
              on: __props.form.wageFee === 'none' || __props.form.wageSelect === 'unselected',
              "aria-label": "임금관리 해당 없음",
              onPick: toggleWageNone
            }, null, 8, ["on"]),
            _cache[41] || (_cache[41] = _createTextVNode(" 해당 없음(미선택) ", -1))
          ]),
          _createElementVNode("span", _hoisted_4, [
            _createVNode(ScMark, {
              on: __props.form.wageFee === 'flat',
              "aria-label": "임금관리 월정액",
              onPick: _cache[0] || (_cache[0] = ($event: any) => (pickWageFee('flat')))
            }, null, 8, ["on"]),
            _cache[42] || (_cache[42] = _createTextVNode(" 월정액 ", -1)),
            _createVNode(ScEditText, {
              modelValue: __props.form.wageFlat,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.form.wageFlat) = $event)),
              width: 8,
              numeric: "",
              disabled: __props.form.wageFee !== 'flat'
            }, null, 8, ["modelValue", "disabled"]),
            _cache[43] || (_cache[43] = _createTextVNode("원 ", -1))
          ]),
          _createElementVNode("span", _hoisted_5, [
            _createVNode(ScMark, {
              on: __props.form.wageFee === 'headcount',
              "aria-label": "임금관리 인원연동",
              onPick: _cache[2] || (_cache[2] = ($event: any) => (pickWageFee('headcount')))
            }, null, 8, ["on"]),
            _cache[44] || (_cache[44] = _createTextVNode(" 인원연동(기본 ", -1)),
            _createVNode(ScEditText, {
              modelValue: __props.form.wageBaseHeadcount,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((__props.form.wageBaseHeadcount) = $event)),
              width: 4,
              numeric: "",
              disabled: __props.form.wageFee !== 'headcount'
            }, null, 8, ["modelValue", "disabled"]),
            _cache[45] || (_cache[45] = _createTextVNode("명 포함, 초과 1명당 ", -1)),
            _createVNode(ScEditText, {
              modelValue: __props.form.wageExtraPerPerson,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((__props.form.wageExtraPerPerson) = $event)),
              width: 8,
              numeric: "",
              disabled: __props.form.wageFee !== 'headcount'
            }, null, 8, ["modelValue", "disabled"]),
            _cache[46] || (_cache[46] = _createTextVNode("원) ", -1))
          ]),
          _createElementVNode("span", _hoisted_6, [
            _createVNode(ScMark, {
              on: __props.form.wageFee === 'custom',
              "aria-label": "임금관리 별도 산식",
              onPick: _cache[5] || (_cache[5] = ($event: any) => (pickWageFee('custom')))
            }, null, 8, ["on"]),
            _cache[47] || (_cache[47] = _createTextVNode(" 별도 산식 ", -1)),
            _createVNode(ScEditText, {
              modelValue: __props.form.wageCustomFormula,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((__props.form.wageCustomFormula) = $event)),
              width: 8,
              disabled: __props.form.wageFee !== 'custom'
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _createElementVNode("p", _hoisted_7, [
          _cache[54] || (_cache[54] = _createTextVNode(" 재무회계: ", -1)),
          _createElementVNode("span", _hoisted_8, [
            _createVNode(ScMark, {
              on: __props.form.acctFee === 'none' || __props.form.acctSelect === 'unselected',
              "aria-label": "재무회계 해당 없음",
              onPick: toggleAcctNone
            }, null, 8, ["on"]),
            _cache[49] || (_cache[49] = _createTextVNode(" 해당 없음(미선택) ", -1))
          ]),
          _createElementVNode("span", _hoisted_9, [
            _createVNode(ScMark, {
              on: __props.form.acctFee === 'flat',
              "aria-label": "재무회계 월정액",
              onPick: _cache[7] || (_cache[7] = ($event: any) => (pickAcctFee('flat')))
            }, null, 8, ["on"]),
            _cache[50] || (_cache[50] = _createTextVNode(" 월정액 ", -1)),
            _createVNode(ScEditText, {
              modelValue: __props.form.acctFlat,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((__props.form.acctFlat) = $event)),
              width: 8,
              numeric: "",
              disabled: __props.form.acctFee !== 'flat'
            }, null, 8, ["modelValue", "disabled"]),
            _cache[51] || (_cache[51] = _createTextVNode("원 ", -1))
          ]),
          _createElementVNode("span", _hoisted_10, [
            _createVNode(ScMark, {
              on: __props.form.acctFee === 'volume',
              "aria-label": "재무회계 업무량연동",
              onPick: _cache[9] || (_cache[9] = ($event: any) => (pickAcctFee('volume')))
            }, null, 8, ["on"]),
            _cache[52] || (_cache[52] = _createTextVNode(" 업무량연동 ", -1)),
            _createVNode(ScEditText, {
              modelValue: __props.form.acctVolume,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((__props.form.acctVolume) = $event)),
              width: 8,
              disabled: __props.form.acctFee !== 'volume'
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("span", _hoisted_11, [
            _createVNode(ScMark, {
              on: __props.form.acctFee === 'custom',
              "aria-label": "재무회계 별도 산식",
              onPick: _cache[11] || (_cache[11] = ($event: any) => (pickAcctFee('custom')))
            }, null, 8, ["on"]),
            _cache[53] || (_cache[53] = _createTextVNode(" 별도 산식 ", -1)),
            _createVNode(ScEditText, {
              modelValue: __props.form.acctCustomFormula,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((__props.form.acctCustomFormula) = $event)),
              width: 8,
              disabled: __props.form.acctFee !== 'custom'
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _createElementVNode("p", _hoisted_12, [
          _cache[55] || (_cache[55] = _createTextVNode(" 월 이용료 합계(선택·개시된 서비스만) ", -1)),
          _createVNode(ScEditText, {
            modelValue: __props.form.monthlyTotal,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((__props.form.monthlyTotal) = $event)),
            numeric: ""
          }, null, 8, ["modelValue"]),
          _cache[56] || (_cache[56] = _createTextVNode("원 ", -1)),
          _createVNode(ScMark, {
            on: __props.form.vatMode === 'included',
            "aria-label": "부가가치세 포함",
            onPick: _cache[14] || (_cache[14] = ($event: any) => (__props.form.vatMode = 'included'))
          }, null, 8, ["on"]),
          _cache[57] || (_cache[57] = _createTextVNode(" 부가가치세 포함 ", -1)),
          _createVNode(ScMark, {
            on: __props.form.vatMode === 'separate',
            "aria-label": "부가가치세 별도",
            onPick: _cache[15] || (_cache[15] = ($event: any) => (__props.form.vatMode = 'separate'))
          }, null, 8, ["on"]),
          _cache[58] || (_cache[58] = _createTextVNode(" 부가가치세 별도 ", -1))
        ]),
        _cache[82] || (_cache[82] = _createElementVNode("p", { class: "sc__field" }, " ※ 별첨 1에서 미선택한 서비스의 금액란·일정란은 비워 두고 “해당 없음”으로 표시합니다. 이미 인쇄된 요금항목이 있어도 별첨 1의 서비스 선택을 대신하지 않습니다. ", -1)),
        _createElementVNode("p", _hoisted_13, [
          _cache[59] || (_cache[59] = _createTextVNode(" 적용 인원·업무량 산정 기준일 [매월 ", -1)),
          _createVNode(ScEditText, {
            modelValue: __props.form.headcountDay,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((__props.form.headcountDay) = $event)),
            width: 4,
            numeric: ""
          }, null, 8, ["modelValue"]),
          _cache[60] || (_cache[60] = _createTextVNode("일] / 기준 정의 ", -1)),
          _createVNode(ScEditText, {
            modelValue: __props.form.headcountDef,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((__props.form.headcountDef) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _cache[83] || (_cache[83] = _createElementVNode("h3", null, "2. 할인·추가업무·청구", -1)),
        _createElementVNode("p", _hoisted_14, [
          _cache[61] || (_cache[61] = _createTextVNode(" 할인/프로모션 조건 ", -1)),
          _createVNode(ScEditText, {
            modelValue: __props.form.discount,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((__props.form.discount) = $event)),
            width: 20
          }, null, 8, ["modelValue"]),
          _cache[62] || (_cache[62] = _createTextVNode(" / 할인 적용기간 ", -1)),
          _createVNode(ScEditText, {
            modelValue: __props.form.discountPeriod,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((__props.form.discountPeriod) = $event)),
            width: 10
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("p", _hoisted_15, [
          _cache[63] || (_cache[63] = _createTextVNode(" 청구 기준 ", -1)),
          _createVNode(ScMark, {
            on: __props.form.billingTiming === 'prepaid',
            "aria-label": "선불",
            onPick: _cache[20] || (_cache[20] = ($event: any) => (__props.form.billingTiming = 'prepaid'))
          }, null, 8, ["on"]),
          _cache[64] || (_cache[64] = _createTextVNode(" 선불 ", -1)),
          _createVNode(ScMark, {
            on: __props.form.billingTiming === 'postpaid',
            "aria-label": "후불",
            onPick: _cache[21] || (_cache[21] = ($event: any) => (__props.form.billingTiming = 'postpaid'))
          }, null, 8, ["on"]),
          _cache[65] || (_cache[65] = _createTextVNode(" 후불 / 청구일 [매월 ", -1)),
          _createVNode(ScEditText, {
            modelValue: __props.form.billDay,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((__props.form.billDay) = $event)),
            width: 4,
            numeric: ""
          }, null, 8, ["modelValue"]),
          _cache[66] || (_cache[66] = _createTextVNode("일] / 납부기한 [매월 ", -1)),
          _createVNode(ScEditText, {
            modelValue: __props.form.dueDay,
            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((__props.form.dueDay) = $event)),
            width: 4,
            numeric: ""
          }, null, 8, ["modelValue"]),
          _cache[67] || (_cache[67] = _createTextVNode("일] / 결제방법 ", -1)),
          _createVNode(ScEditText, {
            modelValue: __props.form.payMethod,
            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((__props.form.payMethod) = $event)),
            width: 8
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("p", _hoisted_16, [
          _cache[68] || (_cache[68] = _createTextVNode(" 납부계좌(필요 시) [은행·계좌번호·예금주: ", -1)),
          _createVNode(ScEditText, {
            modelValue: __props.form.bankAccount,
            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((__props.form.bankAccount) = $event)),
            width: 20
          }, null, 8, ["modelValue"]),
          _cache[69] || (_cache[69] = _createTextVNode("] ", -1))
        ]),
        _createElementVNode("p", _hoisted_17, [
          _cache[70] || (_cache[70] = _createTextVNode(" 월중 개시·종료 정산 방식 ", -1)),
          _createVNode(ScMark, {
            on: __props.form.proration === 'daily',
            "aria-label": "일할",
            onPick: _cache[26] || (_cache[26] = ($event: any) => (__props.form.proration = 'daily'))
          }, null, 8, ["on"]),
          _cache[71] || (_cache[71] = _createTextVNode(" 일할 ", -1)),
          _createVNode(ScMark, {
            on: __props.form.proration === 'monthly',
            "aria-label": "월정액",
            onPick: _cache[27] || (_cache[27] = ($event: any) => (__props.form.proration = 'monthly'))
          }, null, 8, ["on"]),
          _cache[72] || (_cache[72] = _createTextVNode(" 월정액 ", -1)),
          _createVNode(ScMark, {
            on: __props.form.proration === 'other',
            "aria-label": "기타",
            onPick: _cache[28] || (_cache[28] = ($event: any) => (__props.form.proration = 'other'))
          }, null, 8, ["on"]),
          _cache[73] || (_cache[73] = _createTextVNode(" 기타 ", -1)),
          _createVNode(ScEditText, {
            modelValue: __props.form.prorationOther,
            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((__props.form.prorationOther) = $event)),
            width: 10,
            disabled: __props.form.proration !== 'other'
          }, null, 8, ["modelValue", "disabled"])
        ]),
        _createElementVNode("p", _hoisted_18, [
          _cache[74] || (_cache[74] = _createTextVNode(" 추가 인원·추가업무 청구기준 ", -1)),
          _createVNode(ScEditText, {
            modelValue: __props.form.extraFeeRules,
            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((__props.form.extraFeeRules) = $event)),
            width: 20
          }, null, 8, ["modelValue"])
        ]),
        _cache[84] || (_cache[84] = _createElementVNode("p", { class: "sc__field" }, " 추가업무는 사전 견적 및 갑의 승인에 한하여 청구하며, 승인하지 않은 비용은 청구하지 않는다. ", -1)),
        _cache[85] || (_cache[85] = _createElementVNode("h3", null, "3. 연체·환불·변경", -1)),
        _createElementVNode("p", _hoisted_19, [
          _cache[75] || (_cache[75] = _createTextVNode(" 연체 시 지연손해금 조건(적법한 범위) ", -1)),
          _createVNode(ScEditText, {
            modelValue: __props.form.lateFee,
            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((__props.form.lateFee) = $event)),
            width: 16
          }, null, 8, ["modelValue"]),
          _cache[76] || (_cache[76] = _createTextVNode(" / 미기재 시 법정 기준 적용 ", -1))
        ]),
        _createElementVNode("p", _hoisted_20, [
          _cache[77] || (_cache[77] = _createTextVNode(" 선납액·잔여서비스분 정산 및 환불 방식 ", -1)),
          _createVNode(ScEditText, {
            modelValue: __props.form.refundPolicy,
            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((__props.form.refundPolicy) = $event)),
            width: 16
          }, null, 8, ["modelValue"])
        ]),
        _cache[86] || (_cache[86] = _createElementVNode("p", { class: "sc__field" }, " 요금 또는 중요 조건 변경은 본계약 제10조에 따라 사전 안내 후 명시적 합의로 확정한다. ", -1)),
        _createElementVNode("p", _hoisted_21, [
          _cache[78] || (_cache[78] = _createTextVNode(" 요금 적용 개시연월: 임금관리(선택 시) ", -1)),
          _createVNode(ScEditDate, {
            y: __props.form.wageFeeStartYear || __props.form.wageStartYear,
            m: __props.form.wageFeeStartMonth || __props.form.wageStartMonth,
            type: "ym",
            "onUpdate:y": _cache[33] || (_cache[33] = ($event: any) => (__props.form.wageFeeStartYear = $event)),
            "onUpdate:m": _cache[34] || (_cache[34] = ($event: any) => (__props.form.wageFeeStartMonth = $event))
          }, null, 8, ["y", "m"]),
          _cache[79] || (_cache[79] = _createTextVNode(", 재무회계(선택 시) ", -1)),
          _createVNode(ScEditDate, {
            y: __props.form.acctFeeStartYear || __props.form.acctStartYear,
            m: __props.form.acctFeeStartMonth || __props.form.acctStartMonth,
            type: "ym",
            "onUpdate:y": _cache[35] || (_cache[35] = ($event: any) => (__props.form.acctFeeStartYear = $event)),
            "onUpdate:m": _cache[36] || (_cache[36] = ($event: any) => (__props.form.acctFeeStartMonth = $event))
          }, null, 8, ["y", "m"]),
          _cache[80] || (_cache[80] = _createTextVNode(" / 합의일 ", -1)),
          _createVNode(ScEditDate, {
            y: __props.form.feeAgreedYear,
            "onUpdate:y": _cache[37] || (_cache[37] = ($event: any) => ((__props.form.feeAgreedYear) = $event)),
            m: __props.form.feeAgreedMonth,
            "onUpdate:m": _cache[38] || (_cache[38] = ($event: any) => ((__props.form.feeAgreedMonth) = $event)),
            d: __props.form.feeAgreedDay,
            "onUpdate:d": _cache[39] || (_cache[39] = ($event: any) => ((__props.form.feeAgreedDay) = $event))
          }, null, 8, ["y", "m", "d"])
        ])
      ], 10, _hoisted_1))
    : (__props.locked)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(__props.form.annex2Text || '별첨 2에 적힌 내용이 없습니다.'), 1))
      : _withDirectives((_openBlock(), _createElementBlock("textarea", {
          key: 2,
          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((__props.form.annex2Text) = $event)),
          class: "sc__annex2-text",
          rows: "12",
          "aria-label": "별첨 2 문구",
          placeholder: "요금, 청구, 정산 등 이 계약에 적용할 내용을 적습니다"
        }, null, 512)), [
          [_vModelText, __props.form.annex2Text]
        ])
}
}

})